import React, { useContext, useState } from 'react';

export interface FilterContextData {
    remove(id: string): void;
    add(newFilter: Filter): void;
    contains(id: string): void;
    clear(): void;
    items: Filter[];
}

const FilterContext = React.createContext<FilterContextData>({
    remove: () => {},
    add: () => {},
    contains: () => {},
    clear: () => {},
    items: [],
});

export interface FilterProviderParams {
    children: JSX.Element | JSX.Element[];
}

export type FilterType =
    | 'topic'
    | 'desk'
    | 'contributor'
    | 'channel'
    | 'tag'
    | 'promotional-content'
    | 'archived-channel';
export interface Filter {
    _id: string;
    type: FilterType;
    name: string;
}

export const useArticleFilter = (): FilterContextData =>
    useContext(FilterContext);

export const ArticleFilterProvider = ({
    children,
}: FilterProviderParams): JSX.Element => {
    const [items, setItems] = useState<Filter[]>([]);

    const remove = (id: string) =>
        setItems((f) => f.filter((item) => item._id !== id));

    const add = (newFilter: Filter) =>
        setItems((oldFilters) =>
            oldFilters.some(
                (f) => f._id === newFilter._id && f.type === newFilter.type
            )
                ? oldFilters
                : [...oldFilters, newFilter]
        );

    const contains = (id: string) => {
        return items.some((p) => p._id === id);
    };

    const clear = () => setItems([]);

    return (
        <FilterContext.Provider value={{ add, remove, contains, clear, items }}>
            {children}
        </FilterContext.Provider>
    );
};
